import React from 'react';
import { Col, Row } from 'react-bootstrap';

import ContentIssues, {
  getAnswerIssuesField,
  getContentIssuesLabel,
} from '../../../../../commonComponents/ContentIssues/ContentIssues';
import SpellCheckPreview from '../../../../../commonComponents/SpellCheckPreview/SpellCheckPreview';
import WYSIWYG from '../../../../../commonComponents/WYSIWYG/WYSIWYG';
import { sanitizeRichText } from '../../../../../utilities/reRenderFormulas';
import { QuestionExtraInformation } from './QuestionExtraInformation';

export class AnswerTextArea extends React.Component {
  constructor(props) {
    super(props);
  }

  isOptionDisabled = (value) =>
    !this.props.selectOptions.find((option) => option.value === value);

  render() {
    const value = this.props.value || {};
    const title = this.props.title || {};
    const redBorder = this.props.redBorder === true;
    const contentErrors = this.props.contentErrors || [];

    return (
      <Row className="QuestionTextAreaContainer">
        <Col md={10} className="wysiwyng-title">
          {this.props.title}
        </Col>

        <Col md={2} className="question-area-select">
          {!this.props.isFlashCardMode && (
            <select
              className="QuestionTextAreaSelect BorderTextArea form-control"
              data-test="question-order-select-input"
              value={value.order}
              onChange={(event) => {
                this.props.onSelectChange(value.id, event);
              }}
              disabled={this.props.disabled}
              tabIndex={-1}
            >
              <option value={0}>Random</option>
              <option value={1} disabled={this.isOptionDisabled(1)}>
                1
              </option>
              <option value={2} disabled={this.isOptionDisabled(2)}>
                2
              </option>
              <option value={3} disabled={this.isOptionDisabled(3)}>
                3
              </option>
              <option value={4} disabled={this.isOptionDisabled(4)}>
                4
              </option>
            </select>
          )}
        </Col>
        <Col md={12} className="width100" onBlur={this.props.setNoBorderRed}>
          <WYSIWYG
            onChange={this.props.onChangeAnswer}
            redBorder={this.props.redBorder}
            contentError={contentErrors.length > 0}
            value={value.text || ' '}
            disabled={this.props.disabled}
            modalSize
            showWarning={this.props.showWarning}
            onImagePaste={this.props.onImagePaste}
            allowedFormats={[
              ['bold', 'underline'],
              [{ script: 'sub' }, { script: 'super' }],
              ['formula'],
            ]}
          />

          {title === 'Option A (Correct)' && redBorder && (
            <span className="redText">
              You must provide either text or an image for the correct answer.
            </span>
          )}
          {title === 'Option B' && redBorder && (
            <span className="redText">
              You must provide either text or an image for at least one
              incorrect answer.
            </span>
          )}
          {title !== 'Option A (Correct)' &&
            title !== 'Option B' &&
            redBorder && (
              <span className="redText">
                You should fill the previous answer
              </span>
            )}
          <ContentIssues
            messages={contentErrors}
            label={getContentIssuesLabel(getAnswerIssuesField(title))}
          />

          {this.props.spellCheckOn && (
            <SpellCheckPreview value={value.text} showNoErrors />
          )}
          {this.props.substantialChangeCheckbox &&
            (this.props.value.wasAIGenerated ||
              this.props.isCreatingAiQuestion) &&
            this.props.substantialChangeCheckbox(false)}
        </Col>

        {(this.props.originalResponse?.ai_answer ||
          (this.props.isCreatingAiQuestion && value.text?.trim().length > 0)) &&
          this.props.isCorrect && (
            <QuestionExtraInformation
              title="Original AI Answer"
              backgroundColor={
                value.substantialChanges ? '#fce9ccb9' : '#f3f1ff'
              }
              headerColor={
                this.props.isCreatingAiQuestion
                  ? '#ab9dfaff'
                  : value.substantialChanges
                    ? '#ffb889e0'
                    : '#c6bef4'
              }
              body={
                <div
                  className="text"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeRichText(
                      this.props.isCreatingAiQuestion &&
                        !this.props.originalResponse?.ai_answer
                        ? value.text
                        : this.props.originalResponse.ai_answer,
                    ),
                  }}
                />
              }
            />
          )}
      </Row>
    );
  }
}
